import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { hasFieldError } from '@presentation/utils';
import { useField } from 'formik';
import type { FC } from 'react';
import { useMemo, useState } from 'react';
import { InputFieldClearButton } from '..';
import { Input } from '../Input';
import * as Styled from './styled';
import type { InputFieldProps } from './types';

export { ErrorText } from './styled';
export * from './types';

export const InputField: FC<InputFieldProps> = (props) => {
  const { name, type, iconRight, clearButton, ...rest } = props;
  const [field, meta, helpers] = useField<string | number | undefined>(name);

  const [passwordVisible, setPasswordVisible] = useState(false); // EXCEPTIONAL USE OF STATE IN PRESENTATION, THIS COMPONENT IS USED TOO MUCH AND TOO DEEPLY NESTED.

  const isNumber = type === 'number';
  const isPassword = type === 'password';

  const formattedType = useMemo(() => {
    if (isPassword) {
      return passwordVisible ? 'text' : 'password';
    }
    return type;
  }, [isPassword, passwordVisible, type]);

  const formattedIconRight = useMemo(() => {
    if (isPassword) {
      const icon = passwordVisible ? 'eye-slash' : 'eye';
      return <FontAwesomeIcon icon={icon} onClick={() => setPasswordVisible(!passwordVisible)} />;
    }
    return iconRight;
  }, [iconRight, isPassword, passwordVisible]);

  return (
    <>
      <Input
        {...rest}
        name={name}
        type={formattedType}
        onWheel={() => {
          (document?.activeElement as any)?.blur();
        }}
        onBlur={(event) => {
          field.onBlur(event);
          rest.onBlur?.(event);
        }}
        onChange={(e) => {
          const { value } = e.target as any;
          helpers.setValue(isNumber ? Number(value) : value);
        }}
        {...(isNumber
          ? {
              defaultValue: field.value ?? '',
            }
          : {
              value: field.value ?? '',
            })}
        // value={field.value ?? ''}
        hasError={hasFieldError(meta)}
        iconRight={
          <InputFieldClearButton<string | number | undefined>
            {...clearButton}
            value={field.value}
            initialValue={meta.initialValue}
            onClear={(newValue) => {
              helpers.setValue(newValue as any);
              clearButton?.onClear?.(newValue as any);
            }}
          >
            {formattedIconRight}
          </InputFieldClearButton>
        }
      />
      {hasFieldError(meta) && <Styled.ErrorText>{meta.error}</Styled.ErrorText>}
    </>
  );
};
